import { IconType } from "@justhome/react-ui";
import clsx from "clsx";
import { FC } from "react";
import CalculationIcon from "./CalculationIcon";

const CalculationDivider: FC<{
  icon?: IconType;
  primary?: boolean;
}> = ({ icon, primary }) => {
  return (
    <div
      className={clsx("relative w-full", {
        "h-2s flex items-center": icon,
      })}
    >
      <hr className="text-neutral-50 w-full" />
      {icon && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 px-3xs bg-neutral-12">
          <CalculationIcon icon={icon} primary={primary} />
        </div>
      )}
    </div>
  );
};

export default CalculationDivider;
